"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.balance = exports.listRetrievalDealRecords = exports.listStorageDealRecords = exports.showAll = exports.show = exports.info = exports.newAddr = exports.addrs = exports.connectedness = exports.findPeer = exports.peers = exports.health = void 0;

var rpc_pb_1 = require("@textile/grpc-powergate-client/dist/ffs/rpc/rpc_pb");

var rpc_pb_service_1 = require("@textile/grpc-powergate-client/dist/ffs/rpc/rpc_pb_service");

var rpc_pb_2 = require("@textile/grpc-powergate-client/dist/health/rpc/rpc_pb");

var rpc_pb_service_2 = require("@textile/grpc-powergate-client/dist/health/rpc/rpc_pb_service");

var rpc_pb_3 = require("@textile/grpc-powergate-client/dist/net/rpc/rpc_pb");

var rpc_pb_service_3 = require("@textile/grpc-powergate-client/dist/net/rpc/rpc_pb_service");

var rpc_pb_4 = require("@textile/grpc-powergate-client/dist/wallet/rpc/rpc_pb");

var rpc_pb_service_4 = require("@textile/grpc-powergate-client/dist/wallet/rpc/rpc_pb_service");

var loglevel_1 = __importDefault(require("loglevel"));

var logger = loglevel_1.default.getLogger('pow-api');
/**
 * @internal
 */

function health(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logger.debug('health request');
            _context.next = 3;
            return api.unary(rpc_pb_service_2.RPCService.Check, new rpc_pb_2.CheckRequest(), ctx);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.toObject());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.health = health;
/**
 * @internal
 */

function peers(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            logger.debug('peers request');
            _context2.next = 3;
            return api.unary(rpc_pb_service_3.RPCService.Peers, new rpc_pb_3.PeersRequest(), ctx);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", res.toObject());

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.peers = peers;
/**
 * @internal
 */

function findPeer(api, peerId, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logger.debug('find peer request');
            req = new rpc_pb_3.FindPeerRequest();
            req.setPeerId(peerId);
            _context3.next = 5;
            return api.unary(rpc_pb_service_3.RPCService.FindPeer, req, ctx);

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", res.toObject());

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.findPeer = findPeer;
/**
 * @internal
 */

function connectedness(api, peerId, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            logger.debug('find peer request');
            req = new rpc_pb_3.ConnectednessRequest();
            req.setPeerId(peerId);
            _context4.next = 5;
            return api.unary(rpc_pb_service_3.RPCService.Connectedness, req, ctx);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res.toObject());

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.connectedness = connectedness;
/**
 * @internal
 */

function addrs(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            logger.debug('addrs request');
            _context5.next = 3;
            return api.unary(rpc_pb_service_1.RPCService.Addrs, new rpc_pb_1.AddrsRequest(), ctx);

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", res.toObject());

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

exports.addrs = addrs;
/**
 * @internal
 */

function newAddr(api, name, type, makeDefault, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            logger.debug('newAddr request');
            req = new rpc_pb_1.NewAddrRequest();
            req.setName(name);
            req.setAddressType(type);
            req.setMakeDefault(makeDefault);
            _context6.next = 7;
            return api.unary(rpc_pb_service_1.RPCService.NewAddr, req, ctx);

          case 7:
            res = _context6.sent;
            return _context6.abrupt("return", res.toObject());

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

exports.newAddr = newAddr;
/**
 * @internal
 */

function info(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return api.unary(rpc_pb_service_1.RPCService.Info, new rpc_pb_1.InfoRequest(), ctx);

          case 2:
            res = _context7.sent;
            return _context7.abrupt("return", res.toObject());

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
}

exports.info = info;
/**
 * @internal
 */

function show(api, cid, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            req = new rpc_pb_1.ShowRequest();
            req.setCid(cid);
            _context8.next = 4;
            return api.unary(rpc_pb_service_1.RPCService.Show, req, ctx);

          case 4:
            res = _context8.sent;
            return _context8.abrupt("return", res.toObject());

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
}

exports.show = show;
/**
 * @internal
 */

function showAll(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return api.unary(rpc_pb_service_1.RPCService.ShowAll, new rpc_pb_1.ShowAllRequest(), ctx);

          case 2:
            res = _context9.sent;
            return _context9.abrupt("return", res.toObject());

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
}

exports.showAll = showAll;
/**
 * @internal
 */

function listStorageDealRecords(api, config, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var c, req, res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            c = new rpc_pb_1.ListDealRecordsConfig();
            c.setAscending(config.ascending);
            c.setDataCidsList(config.dataCidsList);
            c.setFromAddrsList(config.fromAddrsList);
            c.setIncludeFinal(config.includeFinal);
            c.setIncludePending(config.includePending);
            req = new rpc_pb_1.ListStorageDealRecordsRequest();
            req.setConfig(c);
            _context10.next = 10;
            return api.unary(rpc_pb_service_1.RPCService.ListStorageDealRecords, req, ctx);

          case 10:
            res = _context10.sent;
            return _context10.abrupt("return", res.toObject());

          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
}

exports.listStorageDealRecords = listStorageDealRecords;
/**
 * @internal
 */

function listRetrievalDealRecords(api, config, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var c, req, res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            c = new rpc_pb_1.ListDealRecordsConfig();
            c.setAscending(config.ascending);
            c.setDataCidsList(config.dataCidsList);
            c.setFromAddrsList(config.fromAddrsList);
            c.setIncludeFinal(config.includeFinal);
            c.setIncludePending(config.includePending);
            req = new rpc_pb_1.ListRetrievalDealRecordsRequest();
            req.setConfig(c);
            _context11.next = 10;
            return api.unary(rpc_pb_service_1.RPCService.ListRetrievalDealRecords, req, ctx);

          case 10:
            res = _context11.sent;
            return _context11.abrupt("return", res.toObject());

          case 12:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
}

exports.listRetrievalDealRecords = listRetrievalDealRecords;
/**
 * @internal
 */

function balance(api, address, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            req = new rpc_pb_4.BalanceRequest();
            req.setAddress(address);
            _context12.next = 4;
            return api.unary(rpc_pb_service_4.RPCService.Balance, req, ctx);

          case 4:
            res = _context12.sent;
            return _context12.abrupt("return", res.toObject());

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
}

exports.balance = balance;